import React from 'react';
import QueueManager from '../../components/callcenter/QueueManager';

const CallcenterQueuePage = () => {
  return <QueueManager />;
};

export default CallcenterQueuePage;

